import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import CopyRight from './Shared/CopyRight/CopyRight';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <div>
                <NavMenu />
                <Container fluid="sm">
                    {this.props.children}
                </Container>
                <CopyRight />
            </div>
        );
    }
}
